module.exports = __webpack_public_path__ + "static/media/flag-sq.53835a54.webp";